export const ROOM_TYPES = [
  { value: 1, label: 'Phòng lý thuyết' },
  { value: 2, label: 'Phòng máy tính' },
  { value: 3, label: 'Phòng thí nghiệm' },
  { value: 4, label: 'Phòng thực hành' },
]

export const SUBJECT_TYPES = [
  { value: 'TC', label: 'Thể chất' },
  { value: 'QP', label: 'Quốc phòng' },
]

export const SCORE_TYPES = [
  { value: 1, text: 'Lý thuyết' },
  { value: 2, text: 'Thực hành' },
]

export const ResearchRoleType = Object.freeze({
  MEMBER: 1,
  REVIEWER: 2,
})

export const OSType = Object.freeze({
  WEB: 3,
})

export const LOGIN_TYPE = Object.freeze({
  NORMAL: '1',
  SSO: '2',
})

export const CreditClassType = Object.freeze({
  THEORETICAL: 0,
  PRACTICE: 1,
})

export const OBJECT_GROUP_TYPES = [
  { value: 1, label: 'Sinh viên lớp tín chỉ' },
  { value: 2, label: 'Sinh viên, giảng viên và cán bộ' },
  { value: 3, label: 'Cá nhân/tổ chức ngoài hệ thống' },
]

export const OBJECT_TYPES = [
  { value: 1, label: 'Sinh viên lớp tín chỉ' },
  { value: 2, label: 'Sinh viên Lớp cố định' },
  { value: 3, label: 'Giảng viên' },
  { value: 4, label: 'Cán bộ' },
]

export const CRITERIA_TYPES = [
  { value: 1, label: 'Thanh kéo điểm' },
  { value: 2, label: 'Lựa chọn' },
  { value: 3, label: 'Tự luận' },
]

export const MULTIPLE_CRITERIA_OPTION_TYPES = [
  { value: 0, label: 'Không' },
  { value: 1, label: 'Có' },
]

export const REQUIRED = [
  { value: 0, label: 'Không bắt buộc trả lời' },
  { value: 1, label: 'Có bắt buộc trả lời' },
]

export const EVALUATE_TYPE = [
  { value: 1, label: 'Đánh giá lớp tín chỉ' },
  { value: 2, label: 'Khảo sát/đánh giá chung' },
]

export const EXAM_TYPE = [
  { value: 1, label: 'Viết' },
  { value: 2, label: 'Vấn đáp' },
  { value: 3, label: 'TNKQ trên giấy' },
]

export const RESEARCH_CONFERENCE_MEMBER_TYPES = [
  { value: 1, label: 'Thành viên trong hệ thống' },
  { value: 2, label: 'Thành viên ngoài hệ thống' },
]

export const RESEARCH_TYPES = [
  { value: 1, label: 'Nghiên cứu khoa học' },
  { value: 2, label: 'Sáng kiến' },
]

export const CREDIT_CLASS_TYPES = [
  { value: 0, label: 'Lý thuyết' },
  { value: 1, label: 'Thực hành' },
]
